import type { ConsultingBrokerStewardshipResponse } from "../types";

type Metrics = ConsultingBrokerStewardshipResponse["metrics"];

type CaptureStat = {
  premium: number;
  capturePercent: number;
};

type TwoZoneMetrics = {
  decided: {
    movedOntoPreferred: CaptureStat;
    keptOnPreferred: CaptureStat;
    movedToNonPreferred: { premium: number };
  };
  undecided: {
    inFlightTotal: number;
    toWin: number;
    toDefend: number;
    groupsPending: number;
  };
};

function toTwoZoneMetrics(metrics: Metrics): TwoZoneMetrics {
  const migration = metrics.migration_success;
  const retention = metrics.retention_success;
  const pending = metrics.pending_outcomes;

  return {
    decided: {
      movedOntoPreferred: {
        premium: migration?.strategic_win_premium ?? 0,
        capturePercent: migration?.success_percent ?? 0,
      },
      keptOnPreferred: {
        premium: retention?.strategic_win_premium ?? 0,
        capturePercent: retention?.success_percent ?? 0,
      },
      movedToNonPreferred: {
        premium: metrics.moved_to_non_strategic_premium ?? 0,
      },
    },
    undecided: {
      inFlightTotal: pending?.total_premium ?? 0,
      toWin: pending?.split.non_strategic ?? 0,
      toDefend: (pending?.split.tier_1 ?? 0) + (pending?.split.tier_2 ?? 0),
      groupsPending: pending?.pending_rfp_count ?? 0,
    },
  };
}

export { toTwoZoneMetrics };
export type { TwoZoneMetrics };
